<template>
  <img class="logo" src="~@imagesBrand/logo.svg" :alt="brandName">
</template>

<script>
export default {
  props: {
    brandName: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  height: 2rem;
}
</style>
